import lllconfig from './lllconfig';

export default class LLLProgrammelist {
  constructor(el) {
    this.el = el;

    this.subjectfilter = document.getElementById('lll-subject-filter');

    this.deliveryfilter = document.getElementById('lll-delivery-filter');

    this.dayfilter = document.getElementById('lll-filter-day');

    this.timefilter = document.getElementById('lll-filter-time');

    this.creditsfilter = document.getElementById('lll-filter-credits');
    this.blockfilter = document.getElementById('lll-filter-block'); // ADDED

    this.selectedFilters = {}; // Use an object to store filter values

    this.daymap = {
      Sunday: 0,

      Monday: 1,

      Tuesday: 2,

      Wednesday: 3,

      Thursday: 4,

      Friday: 5,

      Saturday: 6,
    };

    this.currentTime = '';

    this.currentDay = '';
    this.currentBlock = '';

    this.courses = [...this.el.querySelectorAll('li')];

    this.config = lllconfig;

    this.init();
  }

  init() {
    this.loadSubjectsFilters();

    this.loadDeliveryFilters();
    this.loadBlockFilters(); // ADDED

    this.clickHandler();

    this.checkQueryParams();
  }

  showAvailable() {
    [...this.el.querySelectorAll('li')].forEach((course) => {
      if (course.dataset.available == 'true') {
        course.classList.add('available');

        course.insertAdjacentHTML(
          'beforeend',
          `

                    available

                `
        );
      }
    });
  }

  loadSubjectsFilters() {
    this.config.subjects.forEach((subject) => {
      this.subjectfilter.insertAdjacentHTML(
        'beforeend',
        `

                <option value="${subject.id}">${subject.name}</option>

            `
      );
    });
  }

  setSubjectFilter(subject) {
    this.subjectfilter.value = subject;

    this.filter(); // Apply all filters
  }

  setDeliveryFilter(delivery) {
    this.deliveryfilter.value = delivery;

    this.filter(); // Apply all filters
  }
  // ADDED
  setBlockFilter(block) {
    this.blockfilter.value = block;
    this.filter(); // Apply all filters
  }

  loadDeliveryFilters() {
    this.config.delivery_method.forEach((method) => {
      this.deliveryfilter.insertAdjacentHTML(
        'beforeend',
        `

                <option value="${method.id}">${method.name}</option>

            `
      );
    });
  }
  // ADDED
  loadBlockFilters() {
    const blocks = [
      { id: 1, title: 'Block 1 - 16th September-2nd December' },
      { id: 2, title: 'Block 2 - 1st January- 24th March' },
      { id: 3, title: 'Block 3 - 1st April- 21sh June' },
      { id: 4, title: 'Block 4 - 24th June- 9th September' },
    ]; // Assuming blocks are numbered 1 to 4

    blocks.forEach((block) => {
      this.blockfilter.insertAdjacentHTML(
        'beforeend',
        `
                <option value="${block.id}">${block.title}</option>
            `
      );
    });
  }

  setDayFilter(day) {
    this.dayfilter.value = day;

    this.filter(); // Apply all filters
  }

  setTimeFilter(time) {
    this.timefilter.value = time;

    this.filter(); // Apply all filters
  }

  clickHandler() {
    this.subjectfilter.addEventListener('change', (e) => {
      this.selectedFilters['subject'] = e.target.value;

      if (e.target.value !== '') {
        this.setQueryParams('subject', this.getSubjectName(e.target.value));
      } else {
        this.setQueryParams('subject', '');
      }
      this.filter();
    });

    this.deliveryfilter.addEventListener('change', (e) => {
      this.selectedFilters['delivery'] = e.target.value;

      if (e.target.value !== '') {
        this.setQueryParams(
          'delivery',
          this.getDeliveryMethodName(e.target.value)
        );
      } else {
        this.setQueryParams('delivery', '');
      }
      this.filter();
    });

    this.dayfilter.addEventListener('change', (e) => {
      this.selectedFilters['day'] = e.target.value;

      this.setQueryParams('day', e.target.value);
      this.filter();
    });

    this.timefilter.addEventListener('change', (e) => {
      this.selectedFilters['time'] = e.target.value;

      this.setQueryParams('time', e.target.value);
      this.filter();
    });
    this.blockfilter.addEventListener('change', (e) => {
      this.selectedFilters['block'] = e.target.value;
      this.setQueryParams('block', e.target.value);
      this.filter();
    });

    this.creditsfilter.addEventListener('change', (e) => {
      this.filter();
    });
  }

  getSubjectName(id) {
    return this.config.subjects.find((subject) => subject.id == id).name;
  }

  getDeliveryMethodName(id) {
    return this.config.delivery_method.find(
      (delivery_method) => delivery_method.id == id
    ).name;
  }

  getSubjectId(name) {
    if (name !== '') {
      return this.config.subjects.find((subject) => subject.name == name).id;
    } else {
      return '';
    }
  }

  getDeliveryId(name) {
    if (name !== '') {
      return this.config.delivery_method.find(
        (delivery_method) => delivery_method.name == name
      ).id;
    } else {
      return '';
    }
  }

  checkQueryParams() {
    const params = new URLSearchParams(window.location.search);

    params.forEach((entry, key) => {
      if (entry !== '') {
        switch (key) {
          case 'subject':
            this.selectedFilters['subject'] = this.getSubjectId(entry);

            this.setSubjectFilter(this.getSubjectId(entry));

            return;

          case 'delivery':
            this.selectedFilters['delivery'] = this.getDeliveryId(entry);

            this.setDeliveryFilter(this.getDeliveryId(entry));

            return;

          case 'day':
            this.selectedFilters['day'] = entry;

            this.setDayFilter(entry);

            return;

          case 'time':
            this.selectedFilters['time'] = entry;

            this.setTimeFilter(entry);

            return;
          case 'block':
            this.selectedFilters['block'] = entry;
            this.setBlockFilter(entry);
            return;

          default:
            return;
        }
      }
    });

    this.filter(); // Apply filters on page load
  }

  getQueryParams(name) {
    const params = new URLSearchParams(window.location.search);

    const value = params.get(name);

    if (value) {
      return value;
    } else {
      return null;
    }
  }

  setQueryParams(name, value) {
    const params = new URLSearchParams(window.location.search);

    params.set(name, value);

    window.history.pushState({}, '', `?${params.toString()}`);
  }

  filter() {
    this.courses.forEach((course) => {
      let visible = true; // Assume visible initially

      // Subject filter
      if (this.selectedFilters['subject']) {
        const subject = this.selectedFilters['subject'];
        const subjectsarray = course.dataset.categories.split(',');
        if (subject !== '' && !subjectsarray.includes(subject)) {
          visible = false;
        }
      }

      // Delivery filter
      if (this.selectedFilters['delivery']) {
        const delivery = this.selectedFilters['delivery'];
        const categoriesarray = course.dataset.categories.split(',');
        if (delivery !== '' && !categoriesarray.includes(delivery)) {
          visible = false;
        }
      }

      // Day and Time filter
      if (
        this.selectedFilters['day'] ||
        this.selectedFilters['time'] ||
        this.selectedFilters['block']
      ) {
        const day = this.selectedFilters['day'];
        const time = this.selectedFilters['time'];
        const block = this.selectedFilters['block'];

        let dateMatch = false;
        const dates = course.dataset.dates.split(',');

        for (const date of dates) {
          let dayMatch = true;
          let timeMatch = true;
          let blockMatch = true;

          if (
            day &&
            day !== '' &&
            parseInt(day) !== this.getDayFromDate(date)
          ) {
            dayMatch = false;
          }

          if (
            time &&
            time !== '' &&
            this.getTimeOfDayFromDate(date) &&
            !this.getTimeOfDayFromDate(date).includes(time)
          ) {
            timeMatch = false;
          }
          if (
            block &&
            block !== '' &&
            parseInt(block) !== this.getBlockFromDate(date)
          ) {
            blockMatch = false;
          }

          if (dayMatch && timeMatch && blockMatch) {
            dateMatch = true;
            break;
          }
        }
        if (!dateMatch) {
          visible = false;
        }
      }
      if (this.selectedFilters['block']) {
        const block = this.selectedFilters['block'];
        let dateMatch = false;
        const dates = course.dataset.dates.split(',');

        for (const date of dates) {
          let blockMatch = true;
          if (
            block &&
            block !== '' &&
            parseInt(block) !== this.getBlockFromDate(date)
          ) {
            blockMatch = false;
          }
          if (blockMatch) {
            dateMatch = true;
            break;
          }
        }
        if (!dateMatch) {
          visible = false;
        }
      }

      // Credits filter
      if (this.creditsfilter.checked) {
        if (!course.dataset.categories.split(',').includes('173')) {
          visible = false;
        }
      }

      if (visible) {
        course.classList.remove('hidden');
      } else {
        course.classList.add('hidden');
      }
    });

    this.checkNumberCourses();
  }

  isFiltered(course, category) {
    switch (category) {
      case 'subject':
        return course.dataset.filteredbydatetime == 'true';

      case 'delivery':
        return course.dataset.filteredbydelivery == 'true';

      case 'category':
        return (
          course.dataset.filteredbydatetime == 'true' ||
          course.dataset.filteredbycategory == 'true'
        );

      case 'datetime':
        return course.dataset.filteredbycategory == 'true';

      case 'day':
        return (
          course.dataset.filteredbytime == 'true' ||
          course.dataset.filteredbycategory == 'true'
        );

      case 'time':
        return (
          course.dataset.filteredbyday == 'true' ||
          course.dataset.filteredbycategory == 'true'
        );
      case 'block':
        return (
          course.dataset.filteredbyblock == 'true' ||
          course.dataset.filteredbycategory == 'true'
        );

      default:
        break;
    }
  }

  filterByDayTime(day, time) {
    this.courses.forEach((course) => {
      const dates = course.dataset.dates.split(',');

      function debugcourse(course, message) {
        console.log(message);
      }

      let availabletime = false;

      dates.forEach((date) => {
        debugcourse(course, `Checking date ${date}`);

        debugcourse(course, `filter is ${day} ${time}`);

        debugcourse(course, `day is ${this.getDayFromDate(date)}`);

        debugcourse(course, `time is ${this.getTimeOfDayFromDate(date)}`);

        debugcourse(course, `block is ${this.getBlockFromDate(date)}`);

        if (day !== '' && time !== '') {
          if (
            day == this.getDayFromDate(date) &&
            time == this.getTimeOfDayFromDate(date)
          ) {
            debugcourse(course, `match day and time`);

            debugcourse(
              course,
              `is filtered ${this.isFiltered(course, 'day')}`
            );

            if (
              !this.isFiltered(
                course,
                'day' && !this.isFiltered(course, 'time')
              )
            ) {
              course.classList.remove('hidden');

              course.dataset.filteredbydatetime = false;

              course.dataset.filteredbyday = false;

              course.dataset.filteredbytime = false;

              availabletime = true;
            } else {
              course.classList.add('hidden');

              course.dataset.filteredbydatetime = true;

              course.dataset.filteredbyday = true;

              course.dataset.filteredbytime = true;
            }
          } else {
            course.classList.add('hidden');

            course.dataset.filteredbydatetime = true;

            course.dataset.filteredbyday = true;

            course.dataset.filteredbytime = true;
          }
        } else if (day !== '') {
          course.dataset.filteredbyday = false;

          if (day == this.getDayFromDate(date)) {
            debugcourse(course, `match day`);

            debugcourse(
              course,
              `is filtered ${this.isFiltered(course, 'day')}`
            );

            if (!this.isFiltered(course, 'day')) {
              course.classList.remove('hidden');

              course.dataset.filteredbydatetime = false;

              course.dataset.filteredbyday = false;
            } else {
              course.classList.add('hidden');

              course.dataset.filteredbydatetime = true;

              course.dataset.filteredbyday = true;
            }
          } else {
            course.classList.add('hidden');

            course.dataset.filteredbydatetime = true;

            course.dataset.filteredbyday = true;
          }
        } else if (time !== '') {
          course.dataset.filteredbytime = false;

          if (time == this.getTimeOfDayFromDate(date)) {
            debugcourse(course, `match time of day`);

            debugcourse(
              course,
              `is filtered ${this.isFiltered(course, 'time')}`
            );

            if (!this.isFiltered(course, 'time')) {
              course.classList.remove('hidden');

              availabletime = true;

              course.dataset.filteredbydatetime = false;

              course.dataset.filteredbytime = false;

              course.dataset.timematch = true;
            } else if (!availabletime) {
              course.classList.add('hidden');

              course.dataset.filteredbydatetime = true;

              course.dataset.filteredbytime = true;
            }
          } else {
            course.classList.add('hidden');

            course.dataset.filteredbydatetime = true;

            course.dataset.filteredbytime = true;
          }
        } else if (day === '' && time === '') {
          debugcourse(course, `no match`);

          debugcourse(course, `is filtered ${this.isFiltered(course, 'day')}`);

          if (
            !this.isFiltered(course, 'time') &&
            !this.isFiltered(course, 'day')
          ) {
            course.classList.remove('hidden');

            course.dataset.filteredbydatetime = false;

            course.dataset.filteredbyday = false;

            course.dataset.filteredbytime = false;
          } else {
            course.classList.add('hidden');

            course.dataset.filteredbydatetime = true;

            course.dataset.filteredbyday = true;

            course.dataset.filteredbytime = true;
          }
        }
      });
    });

    this.filterCategories();

    this.checkNumberCourses();
  }

  getDayFromDate(date) {
    const parsedDate = new Date(date);

    return parsedDate.getDay();
  }

  getTimeOfDayFromDate(date) {
    const parsedDate = new Date(date);

    const hour = parsedDate.getHours();

    if (hour == 0) {
      return ['daytime', 'evening'];
    }

    if (hour > 8 && hour <= 17) {
      return ['daytime'];
    }

    if (hour > 17) {
      return ['evening'];
    }

    return;
  }

  getBlockFromDate(date) {
    const parsedDate = new Date(date);

    // Extract month (0-indexed) and day

    const month = parsedDate.getMonth(); // 0 = January, 11 = December

    const day = parsedDate.getDate();

    // Block 1: 16th September - 2nd December

    if (
      (month === 8 && day >= 16) || // September 16-30
      month === 9 || // October
      month === 10 || // November
      (month === 11 && day <= 2) // December 1-2
    ) {
      return 1;
    }

    // Block 2: 1st January - 24th March

    if (
      month === 0 || // January
      month === 1 || // February
      (month === 2 && day <= 24) // March 1-24
    ) {
      return 2;
    }

    // Block 3: 1st April - 21st June

    if (
      month === 3 || // April
      month === 4 || // May
      (month === 5 && day <= 21) // June 1-21
    ) {
      return 3;
    }

    // Block 4: 24th June - 9th September

    if (
      (month === 5 && day >= 24) || // June 24-30
      month === 6 || // July
      month === 7 || // August
      (month === 8 && day <= 9) // September 1-9
    ) {
      return 4;
    }

    // If not in any block (e.g. gap days), return null or throw error

    return null;
  }

  checkNumberCourses() {
    let message = document.getElementById('no-filtered-courses');

    const visible = this.courses.filter((el) => {
      return !el.classList.contains('hidden');
    });

    if (visible.length > 0) {
      message.classList.add('hidden');
    } else {
      message.classList.remove('hidden');
    }
  }
}
